import { SHA256 } from "crypto-js";

export function generateDeviceId(): string {
  // 1. 하드웨어/브라우저 고유 정보 수집
  const components = [
    // 필수 정보 (항상 사용 가능)
    navigator.userAgent,
    navigator.language,
    screen.colorDepth,
    screen.width + "x" + screen.height,
    new Date().getTimezoneOffset(),

    // 선택적 정보 (가능한 경우에만 포함)
    navigator.hardwareConcurrency || "",
    (navigator as any).deviceMemory || "",

    // WebGL 정보
    getWebGLInfo(),

    // 플랫폼 정보 (available in modern browsers)
    navigator.platform || "",
  ].join("|");

  // 2. SHA-256 해시 생성 (32바이트 문자열)
  const hash = SHA256(components).toString();

  // 3. deviceId 저장 및 반환
  const deviceId = hash.slice(0, 32); // 첫 32자만 사용

  // 4. 스토리지에 저장
  try {
    localStorage.setItem("deviceId", deviceId);
  } catch (e) {
    console.warn("Failed to save deviceId to localStorage");
  }

  return deviceId;
}

function getWebGLInfo(): string {
  try {
    const canvas = document.createElement("canvas");
    const gl =
      (canvas.getContext("webgl") as WebGLRenderingContext) ||
      (canvas.getContext("experimental-webgl") as WebGLRenderingContext);

    if (!gl) return "";
    const debugInfo = gl.getExtension("WEBGL_debug_renderer_info");
    if (!debugInfo) return "";

    const vendor = gl.getParameter(debugInfo.UNMASKED_VENDOR_WEBGL);
    const renderer = gl.getParameter(debugInfo.UNMASKED_RENDERER_WEBGL);

    // WebGL 컨텍스트 정리
    const loseContext = gl.getExtension("WEBGL_lose_context");
    if (loseContext) loseContext.loseContext();

    return `${vendor}|${renderer}`;
  } catch (e) {
    return "";
  }
}

export function getDeviceId(): string {
  // 1. localStorage에서 확인
  let deviceId = localStorage.getItem("deviceId");

  // 2. 없으면 생성
  if (!deviceId) {
    deviceId = generateDeviceId();
  }

  return deviceId;
}
